export default "__VITE_ASSET__BNiMWqO6__"